<template>
  <Modal
    name="CREATE_USER_ON_CHECKLIST_MODAL"
    :title="$t('userChecklistModal.title')"
    actions
  >
    <template v-slot:body>
      <span>
        {{ $t('userChecklistModal.message', { user: name })}}
      </span>
    </template>
    <template v-slot:actions>
       <v-btn
        @click="closeAllModals"
        :disabled="isLoading"
        elevation="0"
        class="mr-5"
        text
      >
        {{ $t('userChecklistModal.cancel') }}
      </v-btn>

      <v-btn
        :loading="isLoading"
        color="primary"
        elevation="0"
        @click="create"
      >
        {{ $t('userChecklistModal.confirm')}}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/app/Modal'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'ModalCreateUserOnChecklist',

  components: {
    Modal
  },

  props: {
    type: {
      type: String,
      required: true
    }
  },

  data() {
    return {
    }
  },

  computed: {
    ...mapGetters(['isLoading', 'host', 'hausefulUser']),

    name() {
      return this.type === 'host' ? this.host.name : this.hausefulUser.name
    }
  },

  methods: {
    ...mapActions(['createHostOnChecklist', 'createHausefulUserOnChecklist']),
    ...mapMutations(['closeAllModals']),

    create() {
      if (this.type === 'host') this.createHostOnChecklist(this.host.id)
      else this.createHausefulUserOnChecklist(this.hausefulUser.id)
    },

    mounted() {
      this.name = this.type === 'host' ? this.host.name : this.hausefulUser.name
    },
  },
}
</script>
